/**
 * CheckoutAmounts Component
 */

import { requestDeletePromoCode } from '../../../redux/actions/checkout';
import { getBillingAddress } from '../../../redux/form/selectors';
import { ListItemAnimations } from '../../../utils/animation';
import './checkout-amounts.scss';

import { sortBy } from 'lodash';
import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect } from 'react-redux';
import { VelocityTransitionGroup } from 'velocity-react';

import Button from '../../atoms/buttons/Button';
import { IconX } from '../../atoms/images/Icon';
import Heading from '../../atoms/text/Heading';
import { Span } from '../../atoms/text/Label';
import InvoicePriceTag from '../../atoms/text/PriceTag/InvoicePriceTag';

interface IOwnStateProps {
  billingAddress: IAddress;
}

interface IOwnDispatchProps {
  deletePromoCode: (payload: ICheckoutQueryVariables) => any;
}

interface IOwnMergedProps {
  deletePromoCode: () => any;
}

interface IOwnProps {
  context: 'review' | 'sidebar' | 'invoice';
  order: GQL.IOrder;
}

type CheckoutAmountsProps = IOwnProps & IOwnMergedProps;

const classes = new BEM('checkout__amounts');

class CheckoutAmounts extends React.Component<CheckoutAmountsProps, {}> {

  onRemovePromoCode = () => {
    this.props.deletePromoCode();
  }

  renderLineItemLabel(label: string) {
    return this.props.context === 'review' ? (
      <Heading is="h6" {...classes('item__label')}>{label}</Heading>
    ) : (
        <Span size="medium" {...classes('item__label')}>{label}</Span>
      );
  }

  renderLineItemPriceTag(label: number, explicitCurrency?: boolean) {
    const currency = this.props.order.currency_code! as GQL.Currency;
    const rate = this.props.order.currency_rate!;
    switch (this.props.context) {
      case 'invoice':
        return (
          <InvoicePriceTag
            currency={currency}
            rate={rate}
            amount={label}
            explicitCurrency={explicitCurrency}
            size="small"
            {...classes('item__amount')}
          />
        );
      case 'review':
        return (
          <InvoicePriceTag
            currency={currency}
            rate={rate}
            amount={label}
            explicitCurrency={explicitCurrency}
            size="medium"
            {...classes('item__amount') }
          />
        );
      default:
        return (
          <InvoicePriceTag
            currency={currency}
            rate={rate}
            amount={label}
            explicitCurrency={explicitCurrency}
            size="small"
            {...classes('item__amount') }
          />
        );
    }
  }

  renderTaxLineItem = ({ amount, id, rate, tax_name }: GQL.ITaxLineItem) => (
    <div key={id} {...classes('item') }>
      <div {...classes('item__wrapper') }>
        {this.renderLineItemLabel(`${tax_name!} (${rate}%)`)}
        {this.renderLineItemPriceTag(amount!, this.props.context === 'invoice')}
      </div>
    </div>
  )

  render() {
    const {
      context,
      order: {
        discount,
        promo_code_line_item,
        subtotal,
        tax_line_items,
        total,
      },
    } = this.props;

    const AmountItemAnimations = ListItemAnimations(context === 'review' ? 48 : 40);
    const taxLineItems = sortBy(tax_line_items!, 'priority');

    return (
      <VelocityTransitionGroup
        component="div"
        enter={{ animation: AmountItemAnimations.In, stagger: 150 }}
        leave={{ animation: AmountItemAnimations.Out }}
        {...classes('', context) }
      >
        {promo_code_line_item && context !== 'invoice' && (
          <div {...classes('item', 'promo-code') }>
            <div {...classes('item__wrapper') }>
              <div {...classes('item__background') } />
              {this.renderLineItemLabel(`Promo Code ${promo_code_line_item!.code!.toUpperCase()}`)}
              {this.renderLineItemPriceTag(-discount!, this.props.context === 'invoice')}
              <Button
                onClick={this.onRemovePromoCode}
                icon={<IconX />}
                variant="icon"
                size="xsmall"
                {...classes('item__button-remove') }
              />
            </div>
          </div>
        )}
        <div {...classes('item') }>
          <div {...classes('item__wrapper') }>
            {this.renderLineItemLabel(this.getSubtotalLabel())}
            {this.renderLineItemPriceTag(subtotal!, this.props.context === 'invoice')}
          </div>
        </div>
        {taxLineItems.map(this.renderTaxLineItem)}
        <div {...classes('item') }>
          <div {...classes('item__wrapper') }>
            {this.renderLineItemLabel('Total')}
            {this.renderLineItemPriceTag(total!, true)}
          </div>
        </div>
      </VelocityTransitionGroup>
    );
  }

  getSubtotalLabel() {
    const {
      context,
      order: {
        promo_code_line_item,
      },
    } = this.props;
    const showPromoCode = promo_code_line_item && context === 'invoice';
    return `Subtotal${showPromoCode ? ` (includes promo code ${promo_code_line_item!.code})` : ''}`;
  }
}

const ConnectedCheckoutAmounts = connect<IOwnStateProps, IOwnDispatchProps, IOwnProps, CheckoutAmountsProps>(
  (state: IStoreState) => ({
    billingAddress: getBillingAddress(state),
  }),
  (dispatch) => ({
    deletePromoCode: (payload) => dispatch(requestDeletePromoCode(payload)),
  }),
  ({ billingAddress }, dispatchProps, ownProps) => ({
    ...ownProps,
    deletePromoCode: () => {
      dispatchProps.deletePromoCode({
        country_code: billingAddress ? billingAddress.country : undefined,
        subdivision_code: billingAddress ? billingAddress.state : undefined,
      });
    },
  }),
)(CheckoutAmounts);

export default ConnectedCheckoutAmounts;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/Checkout/CheckoutAmounts.tsx